exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#main-container.top-navigation {\n  max-width: 98%;\n  margin-top: 5%;\n  margin-left: 1%;\n}\n\n#main-container.side-navigation {\n  margin-top: 1%;\n  /*max-width: 84%;\n  margin-left: 14%;*/\n}\n#main-container.side {\n  max-width: 84%;\n    margin-left: 14%;\n}\n/*app-sidebar {\n  max-width: 10%;\n}*/\n\n/*.ui.modal {\n  top: 40% !important;\n}\n*/\n.side-navigation {\n  overflow-x: visible;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main